import StoredLayout from '../../layouts/StoredLayout'
import ActivityWidgets from './ActivityWidgets'
export default StoredLayout(ActivityWidgets)



// WEBPACK FOOTER //
// ./src/widgets/activity-widgets/index.js